<template>
  <div>
    <div class="row my-5" v-if="reports">
      <div class="col-md-6" v-if="selectSchool.options.length">
        <DropSelect
          v-bind="selectSchool"
          v-if="selectSchool.selected !== undefined"
          :zIndex="2"
          :text="'text'"
          @selected="onSelectedItem"
        >
        </DropSelect>
      </div>
      <div class="col text-center" v-if="!selectSchool.options.length">
        <Spinner v-if="showSpinner" />
      </div>
      <div
        class="col-md-6"
        v-if="selectCourse.options.length && selectSchool.selected"
      >
        <DropSelect
          v-bind="selectCourse"
          v-if="selectCourse.selected !== undefined"
          :zIndex="1"
          :text="'text'"
          @selected="onSelectedItem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import DropSelect from "@/components/DropSelect";
import Spinner from "@/components/Spinner";

export default {
  name: "ReportsConfig",
  components: {
    DropSelect,
    Spinner,
  },
  data() {
    return {
      selectSchool: {
        options: [],
        selected: undefined,
        placeholder: "Seleccione Colegio o Sede",
        supTitle: "Colegio o Sede",
        id: "sede",
        icon: "university",
        textKey: "name",
        valueKey: "id",
      },
      selectCourse: {
        options: [],
        selected: undefined,
        placeholder: "Seleccione Curso o Sección",
        supTitle: "Curso o Sección",
        id: "curso",
        icon: "graduation-hat",
        valueKey: "id",
        textKey: "name",
      },
      showSpinner: false,
    };
  },
  computed: {
    ...mapState([
      "reports",
      "dataUrl",
      "teacherData",
      "userData",
      "courseList",
      "tour2",
    ]),
  },
  watch: {
    courseList() {
      if (this.courseList) this.setData();
    },
    "selectCourse.selected"() {
      if (
        this.userData.numberSession < 2 &&
        !this.tour2 &&
        this.selectCourse.options.length &&
        this.selectSchool.selected
      ) {
        this.setTour2(true);
        this.$router.push(
          "/dashboard/analytics/reports?product_tour_id=118288"
        );
      }
    },
  },
  methods: {
    ...mapMutations(["setSchool", "setCourse", "setCourseName", "setTour2"]),
    getUserData() {
      this.selectSchool.options = [this.userData.school];
      this.selectCourse.options = this.courseList;
    },
    onSelectedItem(data) {
      let { id, value } = data;
      switch (id) {
        case "sede":
          this.selectSchool.selected = value;
          this.setSchool(value);
          // this.getCourse(value);
          break;
        case "curso":
          this.selectCourse.selected = value;
          this.setCourse(value);

          this.selectCourse.options.map(i => {
            if (i.id == value) this.setCourseName(i.name);
          });

          break;
      }
    },
    setData() {
      this.selectSchool.selected = this.reports.school;
      this.selectCourse.selected = this.reports.course;

      this.getUserData();
    },
  },
  mounted() {
    if (this.courseList) this.setData();
  },
};
</script>

<style lang="scss" scoped></style>
